import React from 'react';

const CHANNEL_LABELS: Record<string, string> = {
  brake: 'Brk',
  throttle: 'Thr',
  speed: 'Spd',
  steering: 'Str',
  rpm: 'Rpm',
  gear: 'Gr',
};

interface ChannelToolbarProps {
  channels: Record<string, boolean>;
  onToggleChannel: (channel: string) => void;
  isExpanded: boolean;
  onToggleExpand: () => void;
}

const ChannelToolbar: React.FC<ChannelToolbarProps> = ({
  channels,
  onToggleChannel,
  isExpanded,
  onToggleExpand,
}) => (
  <div className="tele-toolbar">
    <span className="tele-toolbar-label">Channels</span>
    <div className="tele-toolbar-chips">
      {Object.entries(CHANNEL_LABELS).map(([key, label]) => (
        <button
          key={key}
          className={`channel-chip ${channels[key] ? 'on' : ''}`}
          onClick={() => onToggleChannel(key)}
        >
          {label}
        </button>
      ))}
      <span className="tele-toolbar-separator" />
      <button
        className={`channel-chip ${channels.delta ? 'on' : ''}`}
        onClick={() => onToggleChannel('delta')}
      >
        Delta
      </button>
    </div>
    <button
      className="tele-expand-btn"
      onClick={onToggleExpand}
      title={isExpanded ? 'Collapse to split view' : 'Expand charts'}
    >
      {isExpanded
        ? <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="1" y1="1" x2="9" y2="9"/><line x1="9" y1="1" x2="1" y2="9"/></svg>
        : <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="0,3 0,0 3,0"/><polyline points="7,0 10,0 10,3"/><polyline points="10,7 10,10 7,10"/><polyline points="3,10 0,10 0,7"/></svg>
      }
    </button>
  </div>
);

export default ChannelToolbar;
